import React, { PropsWithChildren, useEffect } from "react"
import {
    injectIntl,
} from "react-intl"
import { View } from "../../../state/listing/generic-listing"
import SearchService, { SearchData } from "../../../state/search/SearchService"
import GlobalHelper from "../../GlobalHelper.jsx"
import FilterToolbar from "../filters-menu/filterToolbar.component.jsx"

interface OwnProps {
    searchBarClass: string
    childrenClass: string
    key: string
    typeOfSearch: string
    searchKeywords: string
    filtersToUse: object
    object: string[]
    placeholder: string
    savedFilterId: string
    hideFilters: boolean
    hideFilterDropdown: boolean
    productType?: string[]
    view: View
    onChange: (
        searchKeywords: string,
        appliedFilters: object,
        savedFilterId: string,
        searchData: SearchData,
        view: View,
        savePrefs: boolean,
        refreshTotal: boolean,
        resetStatBox: boolean,
    ) => void
}

const Search = (props: PropsWithChildren<OwnProps>) => {
    const { fields, totals, filters } = SearchService.getTotalsFiltersAndFields(props)

    useEffect(() => {
        handleChange(
            props.searchKeywords,
            props.filtersToUse,
            props.savedFilterId,
            props.view,
            false,
        )
    }, [props.filtersToUse])

    const handleChangeSavedFilter = (filterId: string, filters: object, view: View) => {
        if (filters) {
            handleChange(
                props.searchKeywords,
                GlobalHelper.decodeSavedFilter(filters),
                filterId,
                view || { columns: [] },
                true
            )
        }
    }

    const handleChange = (
        keywords: string,
        appliedFilters: object,
        savedFilterId: string,
        view: View,
        resetStatBox: boolean,
    ) => {
        const searchData = SearchService.getSearchPostData(
            appliedFilters,
            props.typeOfSearch,
            filters,
            null,
            props.object,
            totals,
            fields,
            keywords
        )

        props.onChange(
            keywords,
            appliedFilters,
            savedFilterId,
            searchData,
            view,
            true,
            true,
            resetStatBox
        )
    }

    return (
        <div className="ui-has-modules p-0">
            <div className="ui-module p-0">
                <FilterToolbar
                    onKeyPress={e => {
                        const code = e.keyCode || e.charCode
                        if (code === 13) { return }
                    }}
                    minLength={0}
                    debounceTimeout={500}
                    autoComplete="off"
                    name="searchKeywords"
                    value={props.searchKeywords}
                    onChange={({ target }) => handleChange(target.value, props.filtersToUse, props.savedFilterId, props.view, false)}
                    id="searchKeywords"
                    type="text"
                    className="form-control"
                    childrenClass={props.childrenClass}
                    searchBarClass={props.searchBarClass}
                    onClearFilters={() => handleChange("", {}, "", { columns: [] }, true)}
                    filtersApplied={filters}
                    filtersToUse={props.filtersToUse}
                    placeholder={props.placeholder}
                    onChangeFilter={(filters: object) => handleChange(props.searchKeywords, filters, props.savedFilterId, props.view, true)}
                    onChangeSavedFilter={handleChangeSavedFilter}
                    listingType={props.typeOfSearch}
                    savedFilterId={props.savedFilterId}
                    hideFilters={props.hideFilters}
                    hideFilterDropdown={props.hideFilterDropdown}
                    view={props.view}
                >
                    {props.children}
                </FilterToolbar>
            </div>
        </div>
    )
}

export default injectIntl(Search)



// WEBPACK FOOTER //
// ./src/common/search-filter/search/search.tsx